<template>
  <div class="modal fade" id="jwtTokenModal" tabindex="-1" aria-labelledby="jwtTokenModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="jwtTokenModalLabel">{{ $t('api_token_modal.your_api_token') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="$t('shared.close')"></button>
        </div>
        <div class="modal-body">
          <i18n-t keypath="api_token_modal.copy_and_save_this_api_token" tag="p" scope="global">
            <template #warning><b>{{ $t('api_token_modal.this_token_will_not_be_displayed') }}</b></template>
          </i18n-t>
          <pre id="jwtToken"><code>{{ jwtToken }}</code></pre>
          <button class="btn btn-primary" id="copyButton">{{ $t('api_token_modal.copy_to_clipboard') }}</button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('shared.close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';
import { i18n } from '../../i18n';

export default defineComponent({
  props: {
    jwtToken: {
      type: String,
      required: true
    }
  },
  mounted() {
    const jwtTokenModal = document.getElementById('jwtTokenModal');
    const modal = new Modal(jwtTokenModal);
    modal.show();

    const copyButton = document.getElementById('copyButton');

    copyButton.addEventListener('click', () => {
      console.log("Copying JWT token to clipboard:", this.jwtToken);
      navigator.clipboard.writeText(this.jwtToken).then(function() {
        alert(i18n.global.t('api_token_modal.copied_to_clipboard'));
      }, function(err) {
        alert(i18n.global.t('api_token_modal.failed_to_copy_text'), err);
      });
    });
  }
});

</script>
